import React from "react";
import { useField, useFormikContext } from "formik";
import { Input, InputProps } from "reactstrap";
import { FormFieldRow } from "../misc/formFieldRow";

export interface FormSelectRowOption {
  key: string;
  value: string;
  display: string;
}

interface FormSelectRowProps extends Omit<InputProps, "name" | "type"> {
  name: string;
  label: string;
  options: FormSelectRowOption[];
  blankOption?: FormSelectRowOption;
  hidden?: boolean;
}

export const FormSelectRow = (props: FormSelectRowProps) => {
  const [field, meta] = useField<string | undefined>(props.name);
  const { submitCount } = useFormikContext();
  const showError = meta.touched || submitCount > 0;
  const error =
    showError && typeof meta.error === "string" ? meta.error : undefined;
  const { label, options, blankOption, hidden, ...inputProps } = props;

  return (
    <FormFieldRow label={label} error={error} hidden={hidden}>
      <Input
        {...inputProps}
        id={props.name}
        name={props.name}
        type="select"
        value={(props.value as string | undefined) ?? field.value ?? ""}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          field.onChange(event);
          props.onChange?.(event);
        }}
        onBlur={field.onBlur}
        invalid={!!error}
      >
        {blankOption && (
          <option key={blankOption.key} value={blankOption.value}>
            {blankOption.display}
          </option>
        )}
        {options.map((option) => (
          <option key={option.key} value={option.value}>
            {option.display}
          </option>
        ))}
      </Input>
    </FormFieldRow>
  );
};
